<template>
  <va-dropdown
    class="profile-dropdown"
    v-model="isShown"
    boundary-body
    offset="0, 16px"
  >
    <span
      class="profile-dropdown__anchor"
      slot="anchor"
      :style="{color: this.$themes.primary}"
    >
      <slot/>
    </span>
    <div class="profile-dropdown__content">
      <router-link
        v-for="option in options"
        :key="option.name"
        :to="{name: option.redirectTo}"
        class="profile-dropdown__item"
      >
        {{ $t(`user.${option.name}`) }}
      </router-link>
    </div>
  </va-dropdown>
</template>

<script>
export default {
  name: 'profile-section',
  data () {
    return {
      isShown: false,
    }
  },
  props: {
    options: {
      type: Array,
      default: () => [
        {
          name: 'profile',
          redirectTo: 'account',
        },
        {
          name: 'logout',
          redirectTo: 'signup',
        },
      ],
    },
  },
}
</script>

<style lang="scss">
.profile-dropdown {

  &__content {
    background-color: $dropdown-background;
    box-shadow: $gray-box-shadow;
    border-radius: .5rem;
    width: 200px;
    display: flex;
    flex-direction: column;
    padding: 6px 0;
  }

  &__item {
    display: block;
    width: 100%;
    text-align: right;
    padding: 10px 16px;
    color: $vue-darkest-blue;
    text-decoration: none;

    &:hover {
      background: rgba(0,0,0,0.05);
      color: $vue-green;
    }
  }

}
</style>
